exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2x3cpT4607U0Au{align-items:flex-start;display:flex;flex-direction:row;justify-content:space-between;margin:0 16px 0 8px}._6z4DNmGC7fjbiH{padding-bottom:16px;padding-left:8px}.oDUOiOSBZVFiUl{margin:-8px 0 16px}._26Z1D904bDONf4{flex:0 0 auto;padding-top:40px;width:264px}@media only screen and (max-width:711px),only screen and (max-width:1091px) and (min-width:712px){._26Z1D904bDONf4{display:none}}@media only screen and (max-width:991px),only screen and (max-width:1371px) and (min-width:992px){._26Z1D904bDONf4._1hYlnyaEfJPNq9{display:none}}._15DFuVi5BivpyD{flex:0 0 auto;width:436px}", ""]);

// exports
exports.locals = {
	"dueDateSection": "_2x3cpT4607U0Au",
	"dueDateCard": "_6z4DNmGC7fjbiH",
	"dueList": "oDUOiOSBZVFiUl",
	"scrollNavContainer": "_26Z1D904bDONf4",
	"pinnedBoardsMenu": "_1hYlnyaEfJPNq9",
	"dueDateLists": "_15DFuVi5BivpyD"
};